import { render, staticRenderFns } from "./brush8.vue?vue&type=template&id=a9897ebc&scoped=true&"
import script from "./brush8.vue?vue&type=script&lang=js&"
export * from "./brush8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9897ebc",
  null
  
)

export default component.exports